export type Variant = 'position-1' | 'position-2' | 'position-3' | 'position-4'

interface DataItem {
  x: number | string | null
  y: number | string | null
  width: string | null
  height: string | null
  style: Record<string, string>
}

export function useSvgData(variant: Variant, size: number): DataItem[] {
  const half = `${size / 2}px`
  const normal = `${size}px`
  const double = `${size * 2}px`

  const svgData: Record<Variant, DataItem[]> = {
    'position-1': [
      {
        x: 0,
        y: 0,
        width: normal,
        height: null,
        style: { height: `calc(50% - ${half})` }
      },
      {
        x: normal,
        y: 0,
        width: normal,
        height: normal,
        style: { transform: `translateY(calc(50% - ${half}))` }
      },
      {
        x: 0,
        y: half,
        width: normal,
        height: null,
        style: {
          height: `calc(50% - ${half} + 1px)`,
          transform: `translateY(50%)`
        }
      }
    ],
    'position-3': [
      {
        x: null,
        y: 0,
        width: normal,
        height: null,
        style: {
          height: `calc(50% - ${half})`,
          transform: `translateX(calc(100% - ${normal}))`
        }
      },
      {
        x: null,
        y: 0,
        width: normal,
        height: normal,
        style: {
          transform: `translate(calc(100% - ${double}), calc(50% - ${half}))`
        }
      },
      {
        x: null,
        y: half,
        width: normal,
        height: null,
        style: {
          height: `calc(50% - ${half} + 1px)`,
          transform: `translate(calc(100% - ${normal}), 50%)`
        }
      }
    ],
    'position-2': [
      {
        x: 0,
        y: 0,
        width: null,
        height: normal,
        style: { width: `calc(50% - ${half})` }
      },
      {
        x: 0,
        y: normal,
        width: normal,
        height: normal,
        style: { transform: `translateX(calc(50% - ${half}))` }
      },
      {
        x: half,
        y: 0,
        width: null,
        height: normal,
        style: {
          width: `calc(50% - ${half} + 1px)`,
          transform: `translateX(50%)`
        }
      }
    ],
    'position-4': [
      {
        x: 0,
        y: null,
        width: null,
        height: normal,
        style: {
          width: `calc(50% - ${half})`,
          transform: `translateY(calc(100% - ${normal} + 1px))`
        }
      },
      {
        x: 0,
        y: null,
        width: normal,
        height: normal,
        style: {
          transform: `translate(calc(50% - ${half}), calc(100% - ${double} + 1px))`
        }
      },
      {
        x: half,
        y: null,
        width: null,
        height: normal,
        style: {
          width: `calc(50% - ${half})`,
          transform: `translate(50%, calc(100% - ${normal} + 1px))`
        }
      }
    ]
  }

  return svgData[variant] || []
}
